import React from "react";
import { Link } from "react-router-dom";
import PaginaEsito from "./esito/PaginaEsito";

// Pagina di esito in italiano, con lo stesso aspetto delle altre pagine di esito
const Error503 = () => (
   <PaginaEsito titolo="Servizio non disponibile" variante="danger">
      <p>Siamo in manutenzione: riprova fra poco.</p>
      <Link className="btn btn-primary btn-add" to="/dashboard">
         Torna alla home
      </Link>
   </PaginaEsito>
);

export default Error503;
